import { lazy } from "react";
import { createFileRoute } from "@tanstack/react-router";

const PartnerImport = lazy(() => import("@/pages/partner/PartnerImport"));

export const Route = createFileRoute("/partner/import")({
  head: () => ({
    meta: [
      { title: "Importera avtal – Partnerportal" },
      {
        name: "description",
        content: "Importera och exportera elavtal som partner på Elmarknad.se.",
      },
      { name: "robots", content: "noindex,nofollow" },
    ],
  }),
  component: () => <PartnerImport />,
});
